import { useEkardoLazyQuery } from '../useEkardoLazyQuery';

import { GET_CONTENT_PAGE_QUERY } from './useContentPage.graphql';
import {
  IGetContentPageQueryGraphQLResponse,
  IGetContentPageQueryVariables,
  IHandleGetContentPageParams,
  IUseContentPage,
  IUseContentPageOptions,
} from './useContentPage.interfaces';

import { Logger } from '../../core';

const useContentPage = (options?: IUseContentPageOptions): IUseContentPage => {
  const { fetchPolicy, onCompleted, onError, product, query, token } = options ?? ({} as IUseContentPageOptions);

  const [executeGetContentPage, { loading: isLoading }] = useEkardoLazyQuery<
    IGetContentPageQueryGraphQLResponse,
    IGetContentPageQueryVariables
  >({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          contentPage: { getContentPage: contentPage },
        } = data;

        new Logger().log(contentPage);

        onCompleted({
          contentPage,
        });
      },
      onError,
    },
    product,
    query: query ?? GET_CONTENT_PAGE_QUERY,
    token,
  });

  const handleGetContentPage = async ({ contentPageId, userFlowStepTrackId, withAnswers }: IHandleGetContentPageParams) => {
    await executeGetContentPage({
      variables: {
        contentPageId,
        userFlowStepTrackId,
        withAnswers,
      },
    });
  };

  return {
    handleGetContentPage,
    isLoading,
  };
};

export { useContentPage };
